import { getDefaultLineForThreshold, getLineStyleForDefaultThresholdLine, getThresholdFeature } from './getters';
import { getLatestValue } from '../../engine';
import { formatValueAsMetricNumber } from '../../formatting/numberFormatter';
import { DataTable, EffectiveDefinition, ValueAccessor } from '../../models';
import { accessorForReference } from '../../models/Accessor';
import { buildTimestampAccessor, getMeasureFormatString } from '../metricValue';
import { LineLabelStyle } from './models';

export function buildFirstThresholdMeasureAccessor(
  effectiveDefinition: EffectiveDefinition
): ValueAccessor<number | undefined> | undefined {
  const feature = getThresholdFeature(effectiveDefinition.features);
  const line = getDefaultLineForThreshold(feature);
  if (!line) {
    return undefined;
  }
  return accessorForReference(line.measure);
}

export const buildFirstThresholdTimestampAccessor = (
  effectiveDefinition: EffectiveDefinition
): ValueAccessor<Date | undefined> | undefined => {
  const feature = getThresholdFeature(effectiveDefinition.features);
  const line = getDefaultLineForThreshold(feature);
  if (!line?.timestamp) {
    return undefined;
  }
  return accessorForReference(line.timestamp);
};

export const buildComparisonLineLabelAccessor = (
  definition: EffectiveDefinition,
  table: DataTable
): ValueAccessor<string | undefined> | undefined => {
  const labelType = getLineStyleForDefaultThresholdLine(definition);
  switch (labelType?.lineLabel) {
    case LineLabelStyle.LATEST_VALUE:
      const comparisonAccessor = buildFirstThresholdMeasureAccessor(definition);
      if (!comparisonAccessor) {
        return undefined;
      }

      const latestComparisonPoint = getLatestValue(table, comparisonAccessor);
      if (!latestComparisonPoint) {
        return undefined;
      }

      const timestampAccessor = buildTimestampAccessor(definition);
      const formatString = getMeasureFormatString(definition);
      const latestComparisonTimestamp = timestampAccessor(latestComparisonPoint);
      const MAX_CHARACTERS = 6;

      return (row) => {
        if (timestampAccessor(row) === latestComparisonTimestamp) {
          return formatValueAsMetricNumber(comparisonAccessor(row), formatString, MAX_CHARACTERS);
        } else {
          return undefined;
        }
      };
    case LineLabelStyle.NONE:
    case undefined:
    default:
      return undefined;
  }
};
